import React, { Component } from "react";
import classNames from "classnames";
import AppTopbar from "./AppTopbar";
import { AppFooter } from "./AppFooter";
import { AppMenu } from "./AppMenu";
import { authenticationService } from "../../_services";
import { Role } from "../../_helpers";
class DashboardLayout extends Component {
  constructor() {
    super();
    this.state = {
      currentUser: authenticationService.currentUserValue,
      layoutMode: "static",
      layoutColorMode: "dark",
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false
    };

    this.onWrapperClick = this.onWrapperClick.bind(this);
    this.onToggleMenu = this.onToggleMenu.bind(this);
    this.onSidebarClick = this.onSidebarClick.bind(this);
    this.onMenuItemClick = this.onMenuItemClick.bind(this);
    this.createMenu();
  }

  onWrapperClick(event) {
    if (!this.menuClick) {
      this.setState({
        overlayMenuActive: false,
        mobileMenuActive: false
      });
    }

    this.menuClick = false;
  }

  onToggleMenu(event) {
    this.menuClick = true;

    if (this.isDesktop()) {
      if (this.state.layoutMode === "overlay") {
        this.setState({
          overlayMenuActive: !this.state.overlayMenuActive
        });
      } else if (this.state.layoutMode === "static") {
        this.setState({
          staticMenuInactive: !this.state.staticMenuInactive
        });
      }
    } else {
      const mobileMenuActive = this.state.mobileMenuActive;
      this.setState({
        mobileMenuActive: !mobileMenuActive
      });
    }

    event.preventDefault();
  }

  onSidebarClick(event) {
    this.menuClick = true;
  }

  onMenuItemClick(event) {
    if (!event.item.items) {
      this.setState({
        overlayMenuActive: false,
        mobileMenuActive: false
      });
    }
  }

  createMenu() {
    if (this.state.currentUser.role === Role.SuperAdmin) {
      this.menu = [
        {
          label: "Dashboard",
          icon: "pi pi-fw pi-home",
          to: "/aboutus"
        },
        {
          label: "Departments",
          icon: "pi pi-fw pi-user-edit",
          to: "/super-admin/departments"
        },
        {
          label: "Users",
          icon: "pi pi-fw pi-user-edit",
          to: "/super-admin/users"
        },
        {
          label: "Edit User Details",
          icon: "pi pi-fw pi-user-edit",
          to: "/super-admin/edit-user-details"
        }
      ];
    } else {
      this.menu = [
        {
          label: "Dashboard",
          icon: "pi pi-fw pi-home",
          to: "/analytics-dashboard"
        },
        {
          label: "Company Registration List",
          icon: "pi pi-fw pi-user-edit",
          to: "/company-registration-list"
        },
        {
          label: "Company Profile Request",
          icon: "pi pi-fw pi-user-edit",
          to: "/company-profile-requests"
        },
        {
          label: "Publish Company",
          icon: "pi pi-fw pi-user-edit",
          to: "/publish-companies"
        },
        {
          label: "Company Announcements Requests",
          icon: "pi pi-fw pi-pencil",
          to: "/company-highlights-requests"
        },
        {
          label: "Assign Badges",
          icon: "pi pi-fw pi-pencil",
          to: "/assign-badge"
        },
        {
          label: "Sectors",
          icon: "pi pi-fw pi-table",
          to: "/sectors"
          // items: [
          //   {
          //     label: "Sectors",
          //     icon: "pi pi-fw pi-table",
          //     to: "/sectors"
          //   },
          //   // {
          //   //   label: "Services/Keyword",
          //   //   icon: "pi pi-fw pi-table",
          //   //   to: "/servicesKeyword"
          //   // }
          // ]
        },
        {
          label: "Invites",
          icon: "pi pi-fw pi-user-plus",
          items: [
            {
              label: "Invite",
              icon: "pi pi-fw pi-user-plus",
              to: "/invite"
            },
            {
              label: "Add Invites",
              icon: "pi pi-fw pi-user-plus",
              to: "/invite-company-data"
            }
          ]
        },
        {
          label: "Featured Companies",
          icon: "pi pi-fw pi-tags",
          to: "/featured-companies"
        },
        {
          label: "Edit User Details",
          icon: "pi pi-fw pi-user-edit",
          to: "/edit-user-details"
        },
        {
          label: "Verified by Company",
          icon: "pi pi-fw pi-check-circle",
          to: "/verified-by-company"
        },
        {
          label: "Export data",
          icon: "pi pi-fw pi-file-excel",
          to: "/export-company-data"
        }

        // { label: "Inbox", icon: "pi pi-fw pi-envelope", to: "/inbox" }
      ];
    }
  }

  addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else element.className += " " + className;
  }

  removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else
      element.className = element.className.replace(
        new RegExp(
          "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
          "gi"
        ),
        " "
      );
  }

  isDesktop() {
    return window.innerWidth > 1024;
  }

  componentDidUpdate() {
    if (this.state.mobileMenuActive)
      this.addClass(document.body, "body-overflow-hidden");
    else this.removeClass(document.body, "body-overflow-hidden");
  }

  render() {
    const logo =
      this.state.layoutColorMode === "dark"
        ? "/assets/images/weedc_new_logo.svg"
        : "/assets/layout/images/logo.svg";

    const wrapperClass = classNames("layout-wrapper", {
      "layout-overlay": this.state.layoutMode === "overlay",
      "layout-static": this.state.layoutMode === "static",
      "layout-static-sidebar-inactive":
        this.state.staticMenuInactive && this.state.layoutMode === "static",
      "layout-overlay-sidebar-active":
        this.state.overlayMenuActive && this.state.layoutMode === "overlay",
      "layout-mobile-sidebar-active": this.state.mobileMenuActive
    });

    const sidebarClassName = classNames("layout-sidebar", {
      "layout-sidebar-dark": this.state.layoutColorMode === "dark",
      "layout-sidebar-light": this.state.layoutColorMode === "light"
    });

    return (
      <div className={wrapperClass} onClick={this.onWrapperClick}>
        <AppTopbar
          onToggleMenu={this.onToggleMenu}
          logout={(e) => {
            authenticationService.logout();
          }}
        />

        <div
          ref={(el) => (this.sidebar = el)}
          className={sidebarClassName}
          onClick={this.onSidebarClick}
        >
          <div
            className="layout-logo  pb-3 pl-3"
            style={{ height: "90px", width: "200px" }}
          >
            <a href="/aboutus">
              {" "}
              <img alt="Logo" src={logo} />
            </a>
          </div>
          {/* <AppProfile /> */}
          {/* <div className="pb-4 logo-back"></div> */}
          <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
        </div>

        <div className="layout-main">{this.props.children}</div>

        <AppFooter />

        <div className="layout-mask"></div>
      </div>
    );
  }
}

export default DashboardLayout;
